import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import withRole from '../../hoc/role'
import {
  ROLES_IDEAL_ADMIN,
  ROLES_IDEAL_SUPPORT,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from '../../../common/constants'

import styles from '../styles'

const AddButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_add")} disableTriggerFocus={true}>
      <Button aria-label="Add User" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>add</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_IDEAL_ADMIN, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])


const EditButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_edit")} disableTriggerFocus={true}>
      <Button aria-label="Edit" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>edit</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_IDEAL_ADMIN, ...ROLES_IDEAL_SUPPORT, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])
const DeleteButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_delete")} disableTriggerFocus={true}>
      <Button aria-label="Delete" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>delete</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_IDEAL_ADMIN, ...ROLES_IDEAL_SUPPORT, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])
const OrganisationButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("result_organisation")} disableTriggerFocus={true}>
      <Button aria-label="Organisation" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>
        <img src={'/images/organisation.svg'} />
        </Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_IDEAL_ADMIN, ...ROLES_IDEAL_SUPPORT])

class Toolbar extends React.Component {

  render() {

    const {
      classes,
      translate,
      toggle,
      add,
      edit,
      remove,
      loadOrganisationPage,
      selectedRecords,
      toggleFilters,
      data,
      profile,
      viewingAllUsers
    } = this.props

    let allowOrganisation = viewingAllUsers;
    if (selectedRecords.length > 0 && profile.roles  === "idealsupport") {
      let user = data.filter(u => u.id === selectedRecords[0]);
      if (user && (user.length > 0) && (user[0].customer_deleted === true || user[0].role === "idealadmin" || user[0].role === "idealsupport")) {
        allowOrganisation = false;
      }
    }
    return (
      <div>
        <AddButton translate={translate} classes={classes} onClick={() => add()} />
        {(selectedRecords.length > 0) && !viewingAllUsers && (<EditButton translate={translate} classes={classes} onClick={() => edit()} />)}
        {(selectedRecords.length > 0) && !viewingAllUsers && (<DeleteButton translate={translate} classes={classes} onClick={() => remove()} />)}
        {(selectedRecords.length > 0) && allowOrganisation && (<OrganisationButton translate={translate} classes={classes} onClick={() => loadOrganisationPage()} />)}

        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button aria-label="Filter" className={classes.button} color="primary" fab mini onClick={() => toggleFilters()}>
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>

        <Tooltip title={translate("tooltip_view_columns")} disableTriggerFocus={true}>
          <Button aria-label="View Columns" className={classes.button} color="primary" fab mini onClick={() => toggle()}>
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
